<template>
  <div class="DataTable">
    <div class="vld-parent">
      <loading
        :active.sync="isLoading"
        :can-cancel="false"
        :is-full-page="fullPage"
        color="#018389"
        loader="dots"
      ></loading>
    </div>
    <v-form ref="form" v-model="valid" lazy-validation>
      <v-layout row wrap>
        <v-flex xs12 pa-2>
          <span v-if="this.kolicinaVina > 0"
            >Faza {{ this.faza_mark }} / Količina {{ this.kolicinaVina }}
            {{ this.jm_mark }}</span
          >
        </v-flex>
      </v-layout>
      <v-layout row wrap>
        <v-flex xs2 pa-2>
          <v-menu
            ref="menu"
            v-model="menu"
            :close-on-content-click="false"
            :nudge-right="40"
            lazy
            transition="scale-transition"
            offset-y
            full-width
            max-width="290px"
            min-width="290px"
            :disabled="!edit"
          >
            <v-text-field
              slot="activator"
              v-model="dateFormatted"
              label="Datum"
              readonly
              :rules="[(v) => !!v || 'Obavezan podatak']"
              required
              @blur="date = parseDate(dateFormatted)"
              :disabled="!edit"
            ></v-text-field>
            <v-date-picker
              v-model="date"
              no-title
              @input="menu = false"
              :max="maxDate"
            ></v-date-picker>
          </v-menu>
        </v-flex>
        <v-flex xs2 pa-2>
          <v-menu
            ref="menu1"
            :close-on-content-click="false"
            v-model="menu1"
            :nudge-right="0"
            :return-value.sync="time"
            transition="scale-transition"
            lazy
            offset-y
            full-width
            min-width="290px"
            @input="
              (value) =>
                value && $refs.picker && ($refs.picker.selectingHour = true)
            "
            :disabled="!edit"
          >
            <v-text-field
              slot="activator"
              v-model="time"
              label="Vreme"
              readonly
              :rules="[(v) => !!v || 'Obavezan podatak']"
              required
              :disabled="!edit"
            ></v-text-field>
            <v-time-picker
              readonly
              v-model="time"
              ref="picker"
              full-width
              landscape
              class="mt-3"
              format="24hr"
              :allowed-minutes="allowedStep"
              v-on:change="$refs.menu1.save(time)"
            >
              <v-spacer></v-spacer>
              <v-btn flat color="primary" @click="menu1 = false">Cancel</v-btn>
              <!-- <v-btn flat color="primary" @click="$refs.menu1.save(time)">OK</v-btn> -->
            </v-time-picker>
          </v-menu>
        </v-flex>
        <v-flex xs6 pa-2>

        </v-flex>
        <v-flex xs2 pa-2>
          <v-text-field
            v-model="kolicinaIstakanja"
            label="Količina"
            disabled
          ></v-text-field>
        </v-flex>
      </v-layout>
      <!-- /.Name -->

      <v-layout row wrap>
        <v-flex xs12 pa-2>
          <v-text-field
            v-model="opis"
            ref="element4"
            label="Opis"
            :disabled="!edit"
          ></v-text-field>
        </v-flex>
      </v-layout>
      <!-- /.Tank -->

      <v-layout row wrap>
        <v-flex xs10>
          <v-btn
            :disabled="!valid || !edit"
            @click="submit"
            class="AppButtonFilled"
            >Sačuvaj</v-btn
          >
          <v-btn
            @click="clear"
            class="AppButtonOutlined"
            :disabled="!edit"
            v-if="edit"
            >odustani</v-btn
          >
          <v-btn
            @click="clear"
            class="AppButtonOutlined"
            :disabled="!edit"
            v-else
            style="border: none !important"
            >odustani</v-btn
          >
        </v-flex>
        <v-flex xs2>
          <v-btn
            :disabled="ID===0 || !edit"
            @click="obrisiIstakanje"
            class="AppButtonFilled"
            >Obriši</v-btn
          >
        </v-flex>
      </v-layout>
      <!-- /.Action buttons -->
    </v-form>
    <TokenComponent ref="frmtoken" />
  </div>
</template>

<script>
import Loading from "vue-loading-overlay";
import "vue-loading-overlay/dist/vue-loading.css";

import { serverBus } from "../main";
import { readJSON, isNumeric } from "../helpers/Functions";
import TokenComponent from "../components/Token";

export default {
  name: "EmptingItem",
  components: {
    TokenComponent,
    Loading
  },
  data: () => ({
    isLoading: false,
    loading: true,
    fullPage: true,

    valid: true,
    ID: "0",
    opis: "",
    date: null, //For datepicker
    menu: "",
    tankPhaseWineId: 0,
    time: undefined,
    menu1: "",
    kolicinaVina: 0,
    faza_mark: "",
    jm_mark: "",
    date: null,
    dateFormatted: null,
    edit: true,
    kolicinaIstakanja: undefined
  }),
  watch: {
    date(val) {
      this.dateFormatted = this.formatDate1(this.date);
    },
  },
  computed: {
    maxDate() {
      const today = new Date();
      // const dd = today.getUTCDate();
      return this.formatDate(today);
    },
  },
  methods: {
    formatDate1(date) {
      if (!date) return null;

      const [year, month, day] = date.split("-");
      return `${day}.${month}.${year}`;
    },
    parseDate(date) {
      if (!date) return null;

      const [day, month, year] = date.split(".");
      return `${year}-${month.padStart(2, "0")}-${day.padStart(2, "0")}`;
    },
    allowedStep: (m) => m % 5 === 0,
    formatDate(date) {
      let month = `${date.getMonth() + 1}`;
      let day = `${date.getDate()}`;
      const year = date.getFullYear();

      if (month.length < 2) month = `0${month}`;
      if (day.length < 2) day = `0${day}`;

      return [year, month, day].join("-");
    },
    setTime() {
      const today = new Date();
      let Minutes = `${today.getMinutes()}`;
      let Hours = `${today.getHours()}`;

      if (Hours.length < 2) Hours = `0${Hours}`;
      if (Minutes.length < 2) Minutes = `0${Minutes}`;

      this.time = [Hours, Minutes].join(":");
    },
    setDate() {
      const today = new Date();
      let Year = `${today.getFullYear()}`;
      let Month = `${today.getMonth() + 1}`;
      let Day = `${today.getDate()}`;

      if (Month.length < 2) Month = `0${Month}`;
      if (Day.length < 2) Day = `0${Day}`;

      this.date = [Year, Month, Day].join("-");
    },
    formatTime(time) {
      let HH = time.split(":")[0];
      let mm = time.split(":")[1];

      return HH + ":" + mm;
    },
    newSifarnik() {
      var complexObject = {
        id: this.tankPhaseWineId,
        emptyingDate: this.date + "T" + this.time + ":00",
        emptyingDescription: this.opis,
      };

      this.$http
        .post(
          this.globalServiceLocation +
            this.globalPort +
            "/tank_phase_wine/emptying",
          complexObject,
          {
            headers: {
              "Content-Type": "application/json",
              Authorization: "Bearer  " + localStorage.getItem("user-token"),
            },
          }
        )
        .then((response) => {
          this.isLoading = false;
          this.ID = response.data.toTankPhaseWineId;
          this.clear();
        })
        .catch((e) => {
          // // console.log(e.response);

          if (!e.response) {
            this.isLoading = false;
            alert(
              this.$t("error.message")
            );
          } else {
            if (e.response.status === 401) {
              this.$refs.frmtoken
                .osvezavanjeTokena(localStorage.getItem("user-refresh-token"))
                .then((result) => {
                  // // console.log(result);
                  // // console.log("Novi token - " + localStorage.getItem("user-token"));

                  this.$http
                    .post(
                      this.globalServiceLocation +
                        this.globalPort +
                        "/tank_phase_wine/emptying",
                      complexObject,
                      {
                        headers: {
                          "Content-Type": "application/json",
                          Authorization:
                            "Bearer  " + localStorage.getItem("user-token"),
                        },
                      }
                    )
                    .then((response) => {
                      this.isLoading = false;

                      this.ID = response.data.toTankPhaseWineId;
                      this.clear();
                    })
                    .catch((e) => {
                      this.isLoading = false;

                      let pomError = readJSON(e.response.data.message);
                      alert(pomError);
                    });
                });
            } else {
              this.isLoading = false;
              
              let pomError = readJSON(e.response.data.message);
              alert(pomError);
            }
          }
        });
    },
    changeSifarnik() {
      var complexObject = {
        id: this.tankPhaseWineId,
        emptyingDate: this.date + "T" + this.time + ":00",
        emptyingDescription: this.opis,
      };

      this.$http
        .put(
          this.globalServiceLocation +
            this.globalPort +
            "/tank_phase_wine/emptying",
          complexObject,
          {
            headers: {
              "Content-Type": "application/json",
              Authorization: "Bearer  " + localStorage.getItem("user-token"),
            },
          }
        )
        .then((response) => {
          this.isLoading = false;
        })
        .catch((e) => {
          // // console.log(e.response);

          if (!e.response) {
            this.isLoading = false;
            alert(
              this.$t("error.message")
            );
          } else {
            if (e.response.status === 401) {
              this.$refs.frmtoken
                .osvezavanjeTokena(localStorage.getItem("user-refresh-token"))
                .then((result) => {
                  // // console.log(result);
                  // // console.log("Novi token - " + localStorage.getItem("user-token"));

                  this.$http
                    .put(
                      this.globalServiceLocation +
                        this.globalPort +
                        "/tank_phase_wine/emptying",
                      complexObject,
                      {
                        headers: {
                          "Content-Type": "application/json",
                          Authorization:
                            "Bearer  " + localStorage.getItem("user-token"),
                        },
                      }
                    )
                    .then((response) => {
                      this.isLoading = false;
                    })
                    .catch((e) => {
                      this.isLoading = false;

                      let pomError = readJSON(e.response.data.message);
                      alert(pomError);
                    });
                });
            } else {
              this.isLoading = false;

              let pomError = readJSON(e.response.data.message);
              alert(pomError);
            }
          }
        });
    },
    submit() {
      if (this.$refs.form.validate()) {
        this.isLoading = true;

          setTimeout(() => {
            if (this.ID != "" && this.ID != "0") this.changeSifarnik();
            else this.newSifarnik();

            // this.isLoading = false;
          }, 1000);
      }
    },
    obrisiIstakanje(){
      this.$http
        .delete(
          this.globalServiceLocation +
            this.globalPort +
            "/tank_phase_wine/emptying/" +
            this.tankPhaseWineId,
          {
            headers: {
              "Content-Type": "application/json",
              Authorization: "Bearer  " + localStorage.getItem("user-token"),
            },
          }
        )
        .then((response) => {
          this.ID = 0;
          this.clear();
        })
        .catch((e) => {
          // // console.log(e.response);

          if (!e.response) {
            alert(
              this.$t("error.message")
            );
          } else {
            if (e.response.status === 401) {
              this.$refs.frmtoken
                .osvezavanjeTokena(localStorage.getItem("user-refresh-token"))
                .then((result) => {
                  // // console.log(result);
                  // // console.log("Novi token - " + localStorage.getItem("user-token"));

                  this.$http
                    .delete(
                      this.globalServiceLocation +
                        this.globalPort +
                        "/tank_phase_wine/emptying/" +
                        this.tankPhaseWineId,
                      {
                        headers: {
                          "Content-Type": "application/json",
                          Authorization:
                            "Bearer  " + localStorage.getItem("user-token"),
                        },
                      }
                    )
                    .then((response) => {
                      this.ID = 0;
                      this.clear();
                    })
                    .catch((e) => {
                      // // console.log(e.response);

                      let pomError = readJSON(e.response.data.message);
                      alert(pomError);
                    });
                });
            } else {
              let pomError = readJSON(e.response.data.message);
              alert(pomError);
            }
          }
        });
    },
    clear() {
      

      if(this.ID !== 0 && this.ID !== undefined){
        this.getAllSifarnik();
      }
      else{
        this.$refs.element4.reset();
        this.setTime();
        this.setDate();

        this.kolicinaIstakanja = undefined;
      }
      
    },
    getAllSifarnik() {
      if(this.tankPhaseWineId !== undefined)
      this.$http
        .get(
          this.globalServiceLocation +
            this.globalPort +
            "/tank_phase_wine/emptying/" +
            this.tankPhaseWineId,
          {
            headers: {
              "Content-Type": "application/json",
              Authorization: "Bearer  " + localStorage.getItem("user-token"),
            },
          }
        )
        .then((response) => {
          console.log(response);

          

          if (response.data !== "") {
            this.ID = response.data.id;

            this.date = response.data.emptyingDate.split("T")[0];
            this.time = this.formatTime(response.data.emptyingDate.split("T")[1]);

            this.opis = response.data.emptyingDescription;
            this.kolicinaIstakanja = response.data.quantity + ' ' + response.data.quantityMark;
          }
          else{
            this.kolicinaIstakanja = undefined;
            this.ID = 0;
          }
        })
        .catch((e) => {
          // // console.log(e.response);

          if (!e.response) {
            alert(
              this.$t("error.message")
            );
          } else {
            if (e.response.status === 401) {
              this.$refs.frmtoken
                .osvezavanjeTokena(localStorage.getItem("user-refresh-token"))
                .then((result) => {
                  // // console.log(result);
                  // // console.log("Novi token - " + localStorage.getItem("user-token"));

                  this.$http
                    .get(
                      this.globalServiceLocation +
                        this.globalPort +
                        "/tank_phase_wine/emptying/" +
                        this.tankPhaseWineId,
                      {
                        headers: {
                          "Content-Type": "application/json",
                          Authorization:
                            "Bearer  " + localStorage.getItem("user-token"),
                        },
                      }
                    )
                    .then((response) => {
                      if (response.data !== "") {
                        this.ID = response.data.id;

                        this.date = response.data.emptyingDate.split("T")[0];
                        this.time = this.formatTime(response.data.emptyingDate.split("T")[1]);

                        this.opis = response.data.emptyingDescription;
                        this.kolicinaIstakanja = response.data.quantity + ' ' + response.data.quantityMark;
                      }
                      else{
                        this.kolicinaIstakanja = undefined;
                        this.ID = 0;
                      }
                    })
                    .catch((e) => {
                      // // console.log(e.response);

                      let pomError = readJSON(e.response.data.message);
                      alert(pomError);
                    });
                });
            } else {
              let pomError = readJSON(e.response.data.message);
              alert(pomError);
            }
          }
        });
    }
  },
  created() {
    //// // console.log(this.$route.query);

    this.tankPhaseWineId = this.$route.query.id;
  },
  mounted() {
    this.clear();
    this.setTime();
    this.setDate();

    serverBus.$on(
      "empting",
      (
        id,
        kolicina_vina,
        faza_mark,
        jm_mark,
        id_tank,
        tip_tanka,
        edit,
        id_tank_phase_wine_blend
      ) => {
        // alert(id);
        this.tankPhaseWineId = id;
        this.edit = edit;

        this.getAllSifarnik();
      }
    );
  },
};
</script>

<style lang="scss" scoped>
.emptingItemComponentForm {
  max-width: 430px;
}

.Description textarea {
  height: 40px;
}

// .v-input.v-text-field {
// 	margin: 0px;
// }

div.v-input.Description.v-textarea.v-text-field {
  margin-top: 0px;
}

div.flex.pa-2 {
  padding-bottom: 0px !important;
  padding-top: 0px !important;
}
</style>
